import { Box, Button } from '@mui/material';
import React, { Component } from 'react';
import './style.css';

class Summary extends Component {
  continue = e => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      firstname,
      middlename,
      lastname,
      email,
      phone,
      driverlicenceno,
      driverlicencetype,
      driverlicenceversion,
      occupation,
      employer,
      submitData,
      residentialType,
      residencyStatus,
      gender,
      dateOfBirth,
      licenceExpiry,
    } = this.props;

    return (
      <div className="form">
        <div>
          <div className="summary">
            <h2 className="summary__heading">Confirm your personal details</h2>
            <div>
              <div>
                <p>
                  <span className="summary__item-title">First and last name:</span> {firstname} {middlename} {lastname}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Gender:</span> {gender}
                </p>
              </div>

              <div>
                <p>
                  <span className="summary__item-title">Email:</span> {email}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Phone:</span> {phone}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Residency Status:</span> {residencyStatus}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Residential Type:</span> {residentialType}
                </p>
              </div>

              <div>
                <p>
                  <span className="summary__item-title">Date of birth:</span> {dateOfBirth}
                </p>
              </div>
            </div>
          </div>

          <div className="summary">
            <h2 className="summary__heading">Confirm your Licence and Employment details</h2>
            <div>
              <div>
                <p>
                  <span className="summary__item-title">Licence No:</span> {driverlicenceno}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Licence Version:</span> {driverlicenceversion}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Licence Type:</span> {driverlicencetype}
                </p>
              </div>
              <div>
                <p>
                  <span className="summary__item-title">Licence Expiry:</span> {licenceExpiry}
                </p>
              </div>
              <div>
                <div>
                  <span className="summary__item-title">Occupation:</span> {occupation}
                </div>
              </div>
              <div>
                <div>
                  <span className="summary__item-title">Employer:</span> {employer}
                </div>
              </div>
            </div>
          </div>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            {/* <div className="buttons"> */}
            <Button variant="contained" sx={{ backgroundColor: '#b4855a' }} onClick={this.back}>
              Back
            </Button>{' '}
            &nbsp;
            <Button
              variant="contained"
              sx={{ backgroundColor: '#b4855a' }}
              type="submit"
              onClick={e => submitData(e, this.props)}
            >
              Submit
            </Button>
            {/* </div> */}
          </Box>
        </div>
      </div>
    );
  }
}

export default Summary;
